import React from "react";
import _ from "lodash";

import logo from "assets/images/say-what/saywhat-logo.png";

const NoSubmission = ({ photo, over_params, no_captions }) => {
  const winners_label = _.get(
    over_params,
    "no_captions.winners_label",
    "No Winners"
  );
  const try_again = _.get(over_params, "no_captions.try_again", "Try again!");
  const no_captions_text = _.get(
    over_params,
    "no_captions.text",
    "Nobody submitted a caption."
  );
  const no_votes_text = _.get(
    over_params,
    "no_votes.text",
    "Nobody voted for a winning caption"
  );

  return (
    <div className="nobody-cnt">
      <div className="cnt-1">
        <img src={logo} className="sw-logo" alt="logo" />
        <p className="txt">{winners_label}</p>
        <img src={photo} className="caption-img" alt="" />
      </div>
      <div className="cnt-2">
        <p className="nobody-text">
          {no_captions ? no_captions_text : no_votes_text}
        </p>
        <p className="nobody-text">{try_again}</p>
      </div>
    </div>
  );
};

export default NoSubmission;
